import { RoleGuardService } from '@app/auth/services/role-guard.service';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ProxyRouteComponent } from '@shared/components/proxy-route/proxy-route.component';
import { ScreenDialogComponent } from '@shared/components/screen-dialog/screen-dialog.component';
import {
  SingleResolver,
  CollectionResolver,
  SearchResolver,
} from '@core/resolvers';
import { customRoutes } from './custom-master-routing.module';

// palmyra-needle-angular-add-screen-import Do not delete this line. Palmyra will add import screen here
import { MasterVisualizarUsuarioComponent } from '../master/visualizar-usuario/master-visualizar-usuario.component';

import { MasterSearchUserComponent } from '../master/search-user/master-search-user.component';

import { MasterSearch1Component } from '../master/search-1/master-search-1.component';

import { MasterSearch0Component } from '../master/search-0/master-search-0.component';

import { MasterPerfilUsuarioComponent } from '../master/perfil-usuario/master-perfil-usuario.component';

import { MasterPerfilAcessoComponent } from '../master/perfil-acesso/master-perfil-acesso.component';

import { MasterHomeComponent } from './master-home/master-home.component';

import { MasterFundosComponent } from '../master/fundos/master-fundos.component';

import { MasterEdit5Component } from '../master/edit-5/master-edit-5.component';

import { MasterEdit1Component } from '../master/edit-1/master-edit-1.component';

import { MasterEdit0Component } from '../master/edit-0/master-edit-0.component';

import { MasterCreateUserComponent } from '../master/create-user/master-create-user.component';

import { MasterCreateUserWizardComponent } from '../master/create-user-wizard/master-create-user-wizard.component';

import { MasterConsultaUsuariosComponent } from '../master/consulta-usuarios/master-consulta-usuarios.component';

// import { MasterConsultaFundosComponent } from '../master/consulta-fundos/master-consulta-fundos.component';

import { MasterConsultaClientesComponent } from '../master/consulta-clientes/master-consulta-clientes.component';

import { MasterConfirmedMessageComponent } from '../master/confirmed-message/master-confirmed-message.component';

import { MasterCompArrayFormClientsComponent } from '../master/comp-array-form-clients/master-comp-array-form-clients.component';
import { EditUserComponent } from './edit-user/edit-user.component';

import { MasterAssociarFundosComponent } from '../master/associar-fundos/master-associar-fundos.component';

import { MasterAccessProfileComponent } from '../master/access-profile/master-access-profile.component';
import { MasterMasterGroupsComponent } from './master-groups/master-master-groups.component';
import { MasterMasterGroupsUsersComponent } from './master-groups-users/master-master-groups-users.component';
import { MasterMasterGroupsFundosComponent } from './master-groups-fundos/master-master-groups-fundos.component';
import { MasterMasterComponent } from './master/master-master.component';

const routes: Routes = [
  ...customRoutes,
  // palmyra-needle-angular-add-screen-route Do not delete this line. Palmyra will add new route here
  {
    path: '',
    resolve: { inputs: SingleResolver },
    component: MasterMasterComponent,
  },
  {
    path: 'VisualizarUsuario/:id',
    resolve: { inputs: SingleResolver },
    component: MasterVisualizarUsuarioComponent,
    canActivate: [RoleGuardService],
    data: { auth: 'Master' },
  },
  {
    path: 'VisualizarUsuario',
    resolve: { inputs: SingleResolver },
    component: MasterVisualizarUsuarioComponent,
    canActivate: [RoleGuardService],
    data: { auth: 'Master' },
  },

  {
    path: 'SearchUser',
    runGuardsAndResolvers: 'always',
    resolve: { inputs: SearchResolver },
    component: MasterSearchUserComponent,
    children: [
      {
        path: 'master',
        component: ScreenDialogComponent,
        outlet: 'dialog',
        data: undefined,
        children: [
          {
            path: '',
            loadChildren: () =>
              import('@features/master/master.module').then(
                m => m.MasterModule,
              ),
          },
        ],
      },
    ],
  },

  {
    path: 'search-1',
    runGuardsAndResolvers: 'always',
    resolve: { inputs: SearchResolver },
    component: MasterSearch1Component,
  },

  {
    path: 'search-0',
    runGuardsAndResolvers: 'always',
    resolve: { inputs: SearchResolver },
    component: MasterSearch0Component,
  },

  {
    path: 'PerfilUsuario/:id',
    resolve: { inputs: SingleResolver },
    component: MasterPerfilUsuarioComponent,
  },
  {
    path: 'PerfilUsuario',
    resolve: { inputs: SingleResolver },
    component: MasterPerfilUsuarioComponent,
  },

  {
    path: 'perfil-acesso/:id',
    resolve: { inputs: SingleResolver },
    component: MasterPerfilAcessoComponent,
  },
  {
    path: 'perfil-acesso',
    resolve: { inputs: SingleResolver },
    component: MasterPerfilAcessoComponent,
  },

  {
    path: 'master-home/:id',
    resolve: { inputs: SingleResolver },
    component: MasterMasterComponent,
  },
  {
    path: 'master/master',
    resolve: { inputs: SingleResolver },
    component: MasterMasterComponent,
  },

  {
    path: 'fundos/:id',
    resolve: { inputs: SingleResolver },
    component: MasterFundosComponent,
  },
  {
    path: 'fundos',
    resolve: { inputs: SingleResolver },
    component: MasterFundosComponent,
  },

  {
    path: 'edit-5/:id',
    resolve: { inputs: SingleResolver },
    component: MasterEdit5Component,
  },
  {
    path: 'edit-5',
    resolve: { inputs: SingleResolver },
    component: MasterEdit5Component,
  },

  {
    path: 'edit-1/:id',
    resolve: { inputs: SingleResolver },
    component: MasterEdit1Component,
  },
  {
    path: 'edit-1',
    resolve: { inputs: SingleResolver },
    component: MasterEdit1Component,
  },

  {
    path: 'edit-0/:id',
    resolve: { inputs: SingleResolver },
    component: MasterEdit0Component,
  },
  {
    path: 'edit-0',
    resolve: { inputs: SingleResolver },
    component: MasterEdit0Component,
  },

  {
    path: 'create-user/:id',
    resolve: { inputs: SingleResolver },
    component: MasterCreateUserComponent,
    children: [
      {
        path: 'master',
        component: ScreenDialogComponent,
        outlet: 'dialog',
        data: { id: 'btnClose' },
        children: [
          {
            path: '',
            loadChildren: () =>
              import('@features/master/master.module').then(
                m => m.MasterModule,
              ),
          },
        ],
      },
    ],
  },
  {
    path: 'create-user',
    resolve: { inputs: SingleResolver },
    component: MasterCreateUserComponent,
    children: [
      {
        path: 'master',
        component: ScreenDialogComponent,
        outlet: 'dialog',
        data: { id: 'btnClose' },
        children: [
          {
            path: '',
            loadChildren: () =>
              import('@features/master/master.module').then(
                m => m.MasterModule,
              ),
          },
        ],
      },
    ],
  },

  {
    path: 'create-user-wizard',
    resolve: {},
    component: MasterCreateUserWizardComponent,
    children: [
      {
        path: 'CreateUserScreen',
        component: ProxyRouteComponent,
        outlet: 'CreateUserScreen',
        data: { id: 'CreateUserScreen' },
        children: [
          {
            path: '',
            loadChildren: () =>
              import('@features/master/master.module').then(
                m => m.MasterModule,
              ),
          },
        ],
      },
      {
        path: 'AccessProfileScreen',
        component: ProxyRouteComponent,
        outlet: 'AccessProfileScreen',
        data: { id: 'AccessProfileScreen' },
        children: [
          {
            path: '',
            loadChildren: () =>
              import('@features/master/master.module').then(
                m => m.MasterModule,
              ),
          },
        ],
      },
    ],
  },

  {
    path: 'consulta-usuarios/:id',
    resolve: { inputs: SingleResolver },
    component: MasterConsultaUsuariosComponent,
  },
  {
    path: 'consulta-usuarios',
    resolve: { inputs: SingleResolver },
    component: MasterConsultaUsuariosComponent,
  },

  {
    path: 'consulta-clientes/:id',
    resolve: { inputs: SingleResolver },
    component: MasterConsultaClientesComponent,
  },
  {
    path: 'consulta-clientes',
    resolve: { inputs: SingleResolver },
    component: MasterConsultaClientesComponent,
  },

  {
    path: 'ConfirmedMessage/:id',
    resolve: { inputs: SingleResolver },
    component: MasterConfirmedMessageComponent,
  },
  {
    path: 'ConfirmedMessage',
    resolve: { inputs: SingleResolver },
    component: MasterConfirmedMessageComponent,
  },

  {
    path: 'CompArrayFormClients/:id',
    resolve: { inputs: SingleResolver },
    component: MasterCompArrayFormClientsComponent,
  },
  {
    path: 'CompArrayFormClients',
    resolve: { inputs: SingleResolver },
    component: MasterCompArrayFormClientsComponent,
  },

  {
    path: 'associar-fundos/:id',
    resolve: { inputs: SingleResolver },
    component: MasterAssociarFundosComponent,
  },
  {
    path: 'associar-fundos',
    resolve: { inputs: SingleResolver },
    component: MasterAssociarFundosComponent,
  },

  {
    path: 'access-profile/:id',
    resolve: { inputs: SingleResolver },
    component: MasterAccessProfileComponent,
  },
  {
    path: 'access-profile',
    resolve: { inputs: SingleResolver },
    component: MasterAccessProfileComponent,
  },

  {
    path: 'master-groups/:id',
    resolve: { inputs: SingleResolver },
    component: MasterMasterGroupsComponent,
  },
  {
    path: 'master-groups',
    resolve: { inputs: SingleResolver },
    component: MasterMasterGroupsComponent,
  },

  {
    path: 'master-groups-users/:id',
    resolve: { inputs: SingleResolver },
    component: MasterMasterGroupsUsersComponent,
  },
  {
    path: 'master-groups-users',
    resolve: { inputs: SingleResolver },
    component: MasterMasterGroupsUsersComponent,
  },

  {
    path: 'master-groups-fundos/:id',
    resolve: { inputs: SingleResolver },
    component: MasterMasterGroupsFundosComponent,
  },
  {
    path: 'master-groups-fundos',
    resolve: { inputs: SingleResolver },
    component: MasterMasterGroupsFundosComponent,
  },
];

/**
 * The Master routing module
 *
 * @stable
 */
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MasterRoutingModule { }
